import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'

interface IProps {
  desktopView: React.ReactNode
  mobileView: React.ReactNode
}

export const MobileViewSwitcher: React.FC<IProps> = ({ desktopView, mobileView }) => {
  const { isMobile, isTablet } = useWindowDimensions()

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{isMobile || isTablet ? mobileView : desktopView}</>
}
